<div mat-dialog-content>
  <h1 class="title">{{title}}</h1>
    <div class="subtitle">
      Esta informação será compartilhada com o comprador para esclarecer o motivo da recusa.
    </div>
  <mat-form-field>
    <mat-select [(ngModel)]="reason" required>
      <mat-option *ngFor="let r of allReasons" [value]="r.value">
        {{r.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="row mt-3">
    <div class="col-12">
      <button class="btn btn-primary btn-rounded btn-block" (click)="onClickConfirm()" [disabled]="!reason"
        [ngClass]="{loading: !reason}">
        <span>
          CONFIRMAR
        </span>
      </button>
    </div>
    <div class="col-12 mt-2 mb-2">
      <button class="btn btn-transparent btn-rounded btn-block"
        (click)="onNoClick()">CANCELAR</button>
    </div>
  </div>
</div>